import React, { lazy } from 'react';
var DefaultRoute = lazy(function () {
  return import(
  /* webpackChunkName: "default-route-page" */
  './DefaultRoute');
});
export var GlueDefaultRouteObject = [{
  path: '*',
  element: React.createElement(DefaultRoute, null)
}];